import { initMalTypeState } from '../config/initialState';
import {
    MalTypeActionTypes as ActionTypes,
    MalTypeState as State,
    SET_MAL_TYPE,
} from '../types';

export const malTypeReducer = (
    state = initMalTypeState,
    action: ActionTypes
): State => {
    if (action.type === SET_MAL_TYPE) {
        return {
            ...state,
            malTypesCreate: action.payload.malTypesCreate,
            malTypesDelete: action.payload.malTypesDelete,
            malTypesExport: action.payload.malTypesExport,
        };
    }
    return state;
};

export default malTypeReducer;
